const cssRgba = (variable, alpha) => `rgba(${variable("r")}, ${variable("g")}, ${variable("b")}, calc(${alpha()}/100))`;
export { cssRgba };